<template>

  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Usuario</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save" :disabled="isSaving">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="user.name" />
              </div>
              <div class="col-md-6">
                <label for="document-type" class="form-control-label">Tipo de Documento</label>
                <select id="documentType" class="form-control" v-model="user.document_type">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Número documento</label>
                <argon-input type="text" v-model="user.document" autocomplete="off" />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="user.address" autocomplete="off" />
              </div>

              <div class="col-md-6">
                <label for="user-departamento" class="form-control-label">Departamento</label>
                <select id="user-departamento" class="form-control" v-model="user.departamento" @change="onDepartamentoChange">
                  <option value="">Seleccione un departamento</option>
                  <option v-for="dep in departamentos" :key="dep" :value="dep">{{ dep }}</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="user-municipio" class="form-control-label">Municipio</label>
                <select id="user-municipio" class="form-control" v-model="user.municipio" :disabled="!user.departamento">
                  <option value="">Seleccione un municipio</option>
                  <option v-for="mun in municipiosDisponibles" :key="mun" :value="mun">{{ mun }}</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="user-codigo-postal" class="form-control-label">Código Postal</label>
                <argon-input id="user-codigo-postal" type="text" v-model="user.codigo_postal" autocomplete="off" placeholder="Ej: 110111" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Teléfono</label>
                <argon-input type="text" v-model="user.phone" autocomplete="off" />
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Correo electrónico</label>
                <argon-input type="email" v-model="user.email" autocomplete="off" />
              </div>

              

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Contraseña</label>
                <argon-input type="password" v-model="user.password" autocomplete="off" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Confirmar Contraseña</label>
                <argon-input type="password" v-model="user.password_confirmation" autocomplete="off" />
              </div>

              <hr class="my-4">


              
              <div class="col-md-12 my-3">
                <label for="processes-checkbox-list" class="form-control-label">Procesos</label>
                <div id="processes-checkbox-list" class="checkbox-grid">
                  <div v-for="process in processes" :key="process.id">
                    <argon-checkbox :id="'process-' + process.id" :value="process.id"
                      :checked="user.processes.includes(process.id)" v-model="user.processes">
                      {{ process.name }}
                    </argon-checkbox>
                  </div>

                </div>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Forma de pago</label>
                <select name="" id="role" class="form-select" v-model="user.payment">
                  <option value="0">Mensualidad</option>
                  <option value="1">Por Tarea</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Cargo</label>
                <select name="" id="role" class="form-select" v-model="user.role">
                  <option value="1">Administrador</option>
                  <option value="2">Supervisor</option>
                  <option value="3">Operario</option>
                  <option value="4">Cliente</option>
                  <option value="5">Proveedor</option>
                  <option value="6">Cajero</option>
                  <option value="7">Vendedor</option>
                  <option value="8">API (solo integraciones)</option>
                </select>
              </div>

              

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="status" class="form-select" v-model="user.status">
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- Configuración POS para operario -->
      <div class="col-md-4" v-if="isOperario">
        <div class="card">
          <div class="card-header pb-0">
            <p class="mb-0 text-sm font-weight-bold">Configuración POS</p>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-xs text-secondary mb-3">Opciones al vender en punto de venta</p>
            <div class="mb-3">
              <label for="pos-profit-margin" class="form-control-label">Margen de ganancia (%)</label>
              <argon-input
                id="pos-profit-margin"
                type="number"
                min="0"
                max="100"
                step="0.01"
                v-model="user.pos_profit_margin"
                placeholder="0"
              />
              <small class="text-muted">Porcentaje que se suma al precio de lista en el POS.</small>
            </div>
            <div>
              <label for="pos-price-level" class="form-control-label">Lista de precios asignada</label>
              <select id="pos-price-level" class="form-select" v-model="user.pos_price_level">
                <option value="">Todas las listas (1 a 5)</option>
                <option v-for="n in 5" :key="n" :value="String(n)">Lista de precios {{ n }}</option>
              </select>
              <small class="text-muted">Si elige una lista, el operario solo verá ese precio en el POS.</small>
            </div>
          </div>
        </div>
      </div>
      <!-- Columna derecha: permisos de módulos para supervisor -->
      <div class="col-md-4" v-if="isSupervisor">
        <div class="card">
          <div class="card-header pb-0">
            <p class="mb-0 text-sm font-weight-bold">Módulos visibles para el supervisor</p>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-xs text-secondary mb-3">Activar los módulos que puede ver</p>
            <div id="supervisor-modules-checkbox-list" class="checkbox-list-single">
              <div v-for="mod in supervisorModulesList" :key="mod.id">
                <argon-checkbox
                  :id="'mod-' + mod.id"
                  :value="mod.id"
                  :checked="user.supervisor_modules.includes(mod.id)"
                  v-model="user.supervisor_modules">
                  {{ mod.name }}
                </argon-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Listas de precios activas que el API de integración retorna a este usuario -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-header pb-0">
            <p class="mb-0 text-sm font-weight-bold">API – Integraciones</p>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-xs text-secondary mb-3">Listas de precios que el API retorna a este usuario</p>
            <div class="checkbox-list-single">
              <div v-for="n in 5" :key="n">
                <argon-checkbox
                  :id="'price-level-' + n"
                  :value="n"
                  :checked="user.price_levels.includes(n)"
                  v-model="user.price_levels">
                  Lista de precios {{ n }}
                </argon-checkbox>
              </div>
            </div>
            <small class="text-muted">Si no seleccionas ninguna, el API retorna todas las listas (1 a 5).</small>

            <template v-if="isApiRole && user.id > 0">
              <hr class="my-3">
              <p class="text-uppercase text-xs text-secondary mb-2">Token de acceso al API</p>
              <p class="text-xs text-secondary">
                Genera el Bearer Token que usarán las integraciones. Al regenerarlo se revoca el anterior.
              </p>
              <argon-button color="success" size="sm" class="me-2" :disabled="isTokenBusy" @click="generateApiToken">
                Generar token
              </argon-button>
              <argon-button color="danger" size="sm" :disabled="isTokenBusy" @click="revokeApiTokens">
                Revocar tokens
              </argon-button>
            </template>
            <small v-else-if="isApiRole" class="text-muted d-block mt-2">
              Guarda el usuario para poder generarle su token de API.
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.checkbox-list-single {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import { DEPARTMENTS, citiesOfDepartment, canonicalLocation } from "../../../utils/daneCities.js";
import userService from "../../../services/user.service.js";

const body = document.getElementsByTagName("body")[0];


export default {
  name: "User Create",
  data() {
    return {
      showMenu: false,
      isSaving: false,
      isTokenBusy: false,
      user: {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        departamento: '',
        municipio: '',
        codigo_postal: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: '1',
        status: '1',
        phone: '',
        payment: '',
        processes: [],
        supervisor_modules: [],
        pos_profit_margin: 0,
        pos_price_level: '',
        price_levels: [],
      },
      processes: [],
      departamentos: DEPARTMENTS,
      municipiosDisponibles: [],
      supervisorModulesList: [
        { id: 'pos', name: 'POS' },
        { id: 'usuarios', name: 'Usuarios' },
        { id: 'modelo', name: 'Modelo' },
        { id: 'produccion', name: 'Producción' },
        { id: 'operaciones', name: 'Operaciones' },
        { id: 'inventario', name: 'Inventario' },
        { id: 'insumos', name: 'Insumos' },
        { id: 'compras', name: 'Compras' },
        { id: 'remisiones', name: 'Ventas' },
        { id: 'nomina', name: 'Nómina' },
      ],
    };
  },
  components: { ArgonInput, ArgonButton, ArgonCheckbox },
  computed: {
    isSupervisor() {
      return this.user.role === '2' || this.user.role === 2;
    },
    isOperario() {
      return this.user.role === '3' || this.user.role === 3;
    },
    isApiRole() {
      return this.user.role === '8' || this.user.role === 8;
    },
  },
  methods: {
    onDepartamentoChange() {
      this.user.municipio = '';
      this.municipiosDisponibles = citiesOfDepartment(this.user.departamento);
    },
    async getOficios() {
      this.processes = await this.$store.dispatch('users/getOficios');
    },
    async generateApiToken() {
      if (this.isTokenBusy) return;
      this.isTokenBusy = true;
      try {
        const response = await userService.createApiToken(this.user.id);
        const token = response.data?.token;
        if (!token) throw new Error('El API no devolvió ningún token.');
        Swal.fire({
          icon: 'success',
          title: 'Token generado',
          html: `
            <p class="mb-2">Cópialo ahora, <b>no se volverá a mostrar</b>:</p>
            <textarea readonly rows="3" style="width:100%;font-family:monospace;font-size:12px"
              onclick="this.select()">${token}</textarea>`,
          confirmButtonText: 'Copiado / Cerrar',
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo generar el token',
        });
      } finally {
        this.isTokenBusy = false;
      }
    },
    async revokeApiTokens() {
      if (this.isTokenBusy) return;
      const result = await Swal.fire({
        icon: 'warning',
        title: '¿Revocar tokens?',
        text: 'Las integraciones con este usuario dejarán de funcionar hasta que generes un token nuevo.',
        showCancelButton: true,
        confirmButtonText: 'Sí, revocar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#dc3545',
      });
      if (!result.isConfirmed) return;
      this.isTokenBusy = true;
      try {
        await userService.revokeApiTokens(this.user.id);
        await Swal.fire({ icon: 'success', title: 'Tokens revocados' });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudieron revocar los tokens',
        });
      } finally {
        this.isTokenBusy = false;
      }
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Dispara la acción de Vuex para guardar el estudiante
        const payload = { ...this.user };
        if (!this.isOperario) {
          payload.pos_profit_margin = null;
          payload.pos_price_level = null;
        } else {
          payload.pos_profit_margin = payload.pos_profit_margin === '' || payload.pos_profit_margin == null
            ? 0
            : Number(payload.pos_profit_margin);
          payload.pos_price_level = payload.pos_price_level === '' || payload.pos_price_level == null
            ? null
            : Number(payload.pos_price_level);
        }
        // Sin listas seleccionadas se envía null: el API retorna todas (1 a 5).
        payload.price_levels = Array.isArray(this.user.price_levels) && this.user.price_levels.length
          ? [...new Set(this.user.price_levels.map(Number))].sort((a, b) => a - b)
          : null;
        const response = await this.$store.dispatch("users/save", payload);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El usuario ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: 'Users' });
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el usuario');
        }
      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el usuario:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el usuario',
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    }
  },
  mounted() {

    this.getOficios();

    const route = useRoute();
    const data = route.params.user;

    this.$nextTick(() => {
      $(this.$refs.processesSelect).select2();

      $(this.$refs.processesSelect).on('change', (event) => {
        this.user.processes = JSON.stringify($(event.target).val());
      });
    });

    if (data) {
      try {
        const params = JSON.parse(data); // Asegúrate de que este JSON se pueda parsear

        // Verifica si params contiene los datos de user
        if (params && params.id) {
          // Llena los campos del formulario con los datos del usuario
          this.user = params;
          this.user.id = params.id || 0;
          this.user.name = params.name || '';
          this.user.document_type = params.document_type || '';
          this.user.document = params.document || '';
          this.user.address = params.address || '';
          this.user.email = params.email || '';
          this.user.role = params.role || '1';
          this.user.status = params.status || '1';
          this.user.phone = params.phone || '';
          this.user.payment = params.payment || 0;
          // Nombres oficiales del dataset DANE (convierte valores del listado anterior)
          const location = canonicalLocation(params.departamento || '', params.municipio || '');
          this.user.departamento = location.departamento;
          this.user.codigo_postal = params.codigo_postal || '';
          this.municipiosDisponibles = citiesOfDepartment(location.departamento);
          this.user.municipio = location.municipio;
          this.user.processes = JSON.parse(params.processes || '[]') || [];
          if (params.supervisor_modules !== undefined && params.supervisor_modules !== null) {
            this.user.supervisor_modules = Array.isArray(params.supervisor_modules)
              ? [...params.supervisor_modules]
              : (typeof params.supervisor_modules === 'string' ? (params.supervisor_modules ? JSON.parse(params.supervisor_modules) : []) : []);
          } else {
            this.user.supervisor_modules = [];
          }
          this.user.pos_profit_margin = params.pos_profit_margin ?? 0;
          this.user.pos_price_level = params.pos_price_level
            ? String(params.pos_price_level)
            : '';
          this.user.price_levels = Array.isArray(params.price_levels)
            ? params.price_levels.map(Number)
            : [];
          if (this.$refs.processesSelect) {
            $(this.$refs.processesSelect).val(this.user.processes).trigger('change');
          }
        }
      } catch (error) {
        console.error("Error al parsear los datos del usuario:", error);
      }
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
